import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { HcDrawer } from '@hotmart-org-ca/cosmos-web/dist/react/hc-drawer';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useEventListener } from 'src/core/hooks/useEventListener';
import * as styles from './drawer.module.css';
import { DrawerContext } from './drawerContext';
export const Drawer = ({ type, opened, children, onCloseDrawer, dismissButtonAriaLabel, backdropDismissible = false }) => {
    const { t } = useTranslation();
    const ref = useRef(null);
    useEffect(function toggleDrawer() {
        if (opened) {
            ref.current?.open();
        }
        else {
            ref.current?.close();
        }
    }, [opened]);
    useEventListener('closeDrawer', (event) => {
        if (event.target === ref.current)
            onCloseDrawer?.();
    });
    return (_jsx(HcDrawer, { ref: ref, mobileFull: true, 
        // Dismissible button is added manually in header
        dismissible: false, backdropDismissible: backdropDismissible, dismissButtonAriaLabel: dismissButtonAriaLabel || t('general.close'), className: clsx({
            [styles.bottomsheet]: type === 'bottomsheet'
        }), position: type === 'bottomsheet' ? 'bottom' : 'end', children: _jsx(DrawerContext.Provider, { value: {
                closeDrawer: onCloseDrawer
            }, children: children }) }));
};
